import { Box, Typography, IconButton } from "@mui/joy";
import { MoreHorizontal } from "lucide-react";
import ReactECharts from "echarts-for-react";
import { useDashboardData } from "../hooks";

const COLORS = ["#3b82f6", "#35b084", "#f8a250", "#39b6dd", "#8b5cf6", "#f43f5e", "#64748b"];

export default function LeadDistribution() {
    const { leadDistribution } = useDashboardData();
    const { items, total } = leadDistribution;

    const option = {
        textStyle: { fontFamily: "Albert Sans, sans-serif" },
        tooltip: {
            trigger: "item",
        },
        series: [
            {
                type: "pie",
                radius: ["55%", "85%"],
                center: ["50%", "50%"],
                avoidLabelOverlap: false,
                padAngle: 2,
                itemStyle: {
                    borderRadius: 6,
                },
                label: { show: false },
                data: items.map((item, i) => ({
                    value: item.count,
                    name: item.name,
                    itemStyle: { color: COLORS[i % COLORS.length] },
                })),
            },
        ],
        graphic: [
            {
                type: "text",
                left: "center",
                top: "middle",
                style: {
                    text: total.toString(),
                    textAlign: "center",
                    fill: "#1f2937",
                    fontSize: 28,
                    fontWeight: "bold",
                },
            },
        ],
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                    <Typography level="title-lg">Lead Sources</Typography>
                    <Typography level="body-md">Ratio of generated leads</Typography>
                </Box>
                <IconButton>
                    <MoreHorizontal
                        size={20}
                        color="var(--standard-palette-neutral-500)"
                        style={{ cursor: "pointer" }}
                    />
                </IconButton>
            </Box>

            <Box sx={{ height: 220, position: "relative" }}>
                <ReactECharts option={option} style={{ height: "100%", width: "100%" }} opts={{ renderer: "svg" }} />
            </Box>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${Math.min(items.length, 4)}, 1fr)`,
                    gap: 2,
                }}
            >
                {items.map((item, i) => (
                    <Box key={i}>
                        <Typography level="body-sm" sx={{ mb: 0.5 }}>
                            {item.name}
                        </Typography>
                        <Box
                            sx={{
                                height: 6,
                                borderRadius: "sm",
                                bgcolor: COLORS[i % COLORS.length],
                            }}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
